export const userLogin = (token) => ({
  type: '@user/login',
  token
}) 